import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import jwt_decode from "jwt-decode";

function UserDataComponent() {
  const [operator, setOperator] = useState(false);
  const [userData, setUserData] = useState(null);
  const [delegate, setDelegate] = useState(false);
  const [user, setUser] = useState(false);
  const [citizen, setCitizen] = useState(false);

  const [cookies] = useCookies(['api_token', 'user_profile']);

  useEffect(() => {
    if (cookies.api_token && !userData) {
      var decoded = jwt_decode(cookies.api_token);

      // Impostare il valore di operator in base al ruolo dell'utente
      if (decoded.role.includes('OPERATOR')) {
        setOperator(true);
        console.log("operatore");
      }

      // Impostare il valore di delegate in base al ruolo dell'utente
      if (decoded.role.includes('DELEGATE')) {
        setDelegate(true);
        setOperator(false);
        console.log("DELEGATE");
      }

      // Impostare il valore di citizen in base al ruolo dell'utente
      if (decoded.role.includes('CITIZEN')) {
        setCitizen(true);
        console.log("CITIZEN");
      }

      // Impostare il valore di user in base ai dati dell'utente
      setUser(decoded.FullName);

      // Impostare il valore di userData a true per indicare che i dati dell'utente sono stati impostati
      setUserData(true);
    }
  }, [cookies, userData]);

  return {
    operator,
    userData,
    delegate,
    user,
    citizen,
  };
}

export default UserDataComponent;
